export const editMutations = <const>{
	SKLAD_MISTO_SELECT_MAPPER: 'SKLAD_MISTO_SELECT_MAPPER',
	PRACOVNIK_SELECT_MAPPER: 'PRACOVNIK_SELECT_MAPPER',
	NAKLAD_STREDISKO_SELECT_MAPPER: 'NAKLAD_STREDISKO_SELECT_MAPPER',
	PROVOZOVNA_CHANGE: 'provozovnaChange',
	PNEU_SKLAD_SELECT: 'pneuSkladSelect',
};
